import React, { Component } from "react";
import { connect } from 'react-redux';
import { FormGroup, ControlLabel, FormControl, Row, Col } from "react-bootstrap";

class HorizontalFormFileUpload extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange = event => {
    this.props.onValueChange(event.target.files,this.props.statekey, null);
  };
  render() {
    const {label, ncols, hidden, ...rest} = this.props;
    
    var row = [];
    var style = {};
    if(hidden===true) {
      style.display = 'none';
    }

    for (var i = 0; i < ncols.length; i++) {
      row.push(
        <div key={i} className={ncols[i]}>
          <FormGroup style={{ marginBottom: -10 + "px" }}>
            <Col componentClass={ControlLabel} style={{ marginTop: 5 + "px" }} md={4}>
              {label}
            </Col>
            <Col md={8}>
              <FormControl style={{ height: 25 + "px"}} onChange={this.onChange} {...rest} />
            </Col>
          </FormGroup>

        </div>
      );
    }
    return <div style={style}>{row}</div>;
  }
}

export default HorizontalFormFileUpload;
